/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { MARIGOLD_DARK, OLAF } from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import text from 'I18n/utils/unescapedText';
export default class _class extends Component {
  render() {
    const {
      className,
      fieldWarnings,
      i18nKey,
      placement
    } = this.props;
    const warningCount = Object.keys(fieldWarnings).reduce((sum, attributeName) => {
      return fieldWarnings[attributeName].length + sum;
    }, 0);

    if (!warningCount) {
      return null;
    }

    return /*#__PURE__*/_jsx(UITooltip, {
      placement: placement,
      title: text(i18nKey, {
        count: warningCount
      }),
      children: /*#__PURE__*/_jsx(UIIconCircle, {
        backgroundColor: MARIGOLD_DARK,
        borderWidth: 0,
        className: className,
        color: OLAF,
        name: "warning",
        padding: 0.2,
        size: 10
      })
    });
  }

}
_class.propTypes = {
  className: PropTypes.string,
  fieldWarnings: PropTypes.object,
  i18nKey: PropTypes.string,
  placement: PropTypes.string
};
_class.defaultProps = {
  className: null,
  fieldWarnings: {},
  i18nKey: 'DesignEditorsUI.customWidgetEditor.errors.tooltips.fieldWarning',
  placement: 'top'
};